import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';
import css_248z from './file-download-item.scss.js';

class FileDownloadItem extends s {
    constructor() {
        super(...arguments);
        this.cardId = crypto.randomUUID();
    }
    static truncateFileName(name) {
        if (name.length <= 55)
            return name;
        return `${name.substring(0, 52)}...`;
    }
    static truncateButtonLabel(label) {
        if (label.length <= 50)
            return label;
        return `${label.substring(0, 47)}...`;
    }
    render() {
        const truncatedFileName = FileDownloadItem.truncateFileName(this.fileName);
        const truncatedButtonLabel = FileDownloadItem.truncateButtonLabel(this.ctaButton.title);
        const buttonTarget = this.ctaButton.target || '_self';
        const headingId = `${this.cardId}-title`;
        const isDecorativeImage = !this.image.altText || this.image.altText.trim() === '';
        return $ `<article class="file-download-card"><div class="image-wrapper"><generic-image src="${this.image.src}" alt="${this.image.altText || ''}" decorative="${isDecorativeImage ? 'decorative' : ''}" aspect-ratio="2:1" loading="lazy"></generic-image></div><div class="content"><h3 class="file-name" id="${headingId}">${o(truncatedFileName)}</h3><generic-button-updated type="secondary" color="purple" icon="download" .label="${truncatedButtonLabel}" .href="${this.ctaButton.url}" .target="${buttonTarget}" .ariaList="${{ describedby: headingId }}" ?download="${true}" ?rtl="${true}"></generic-button-updated></div></article>`;
    }
}
FileDownloadItem.styles = css_248z;
__decorate([
    e({ type: Object })
], FileDownloadItem.prototype, "image", void 0);
__decorate([
    e({ type: String })
], FileDownloadItem.prototype, "fileName", void 0);
__decorate([
    e({ type: Object })
], FileDownloadItem.prototype, "ctaButton", void 0);
customElements.define('file-download-item-updated', FileDownloadItem);

export { FileDownloadItem };
